export const renderItemLegenda = texto => {
  return `
  <div>
    <div id="itemLegenda">
    <h3>${texto}</h3>
    </div>
  </div>
  `;
};
